<template>
  <v-content>
    <v-layout>
      <v-container app fluid>
        <v-card
          max-width="480px"
          class="mx-auto px-5 py-2 my-5"
          justify="center"
          align="center"
        >
          <v-col>
            <v-row>
              <v-row class="heading">
                <h2>Macro Calculator</h2>
              </v-row>
              <v-subheader>Under Development!</v-subheader>
            </v-row>
            <v-row>
              <v-text-field
                label="Desired Calorie Intake"
                v-model="calories"
                @change="calsChanged"
              ></v-text-field>
            </v-row>
            <v-row>
              <v-subheader>Protein | {{ proteinPercentage }}%</v-subheader>
            </v-row>
            <v-row>
              <v-slider
                v-model="proteinPercentage"
                @change="proteinChanged"
                thumb-label
                step="1"
                min="0"
                max="100"
              ></v-slider>
              <v-text-field
                @input="proteinChanged"
                type="number"
                v-model="proteinPercentage"
                class="inputField flex-row-reverse mt-0 pt-0"
                outlined
                dense
              ></v-text-field>
            </v-row>
            <v-row>
              <v-subheader>Carbs | {{ carbPercentage }}%</v-subheader>
            </v-row>
            <v-row>
              <v-slider
                v-model="carbPercentage"
                @change="carbChanged"
                thumb-label
                step="1"
                min="0"
                max="100"
              ></v-slider>
              <v-text-field
                @input="carbChanged"
                type="number"
                v-model="carbPercentage"
                class="inputField flex-row-reverse mt-0 pt-0"
                outlined
                dense
              ></v-text-field>
            </v-row>
            <v-row>
              <v-subheader>Fat | {{ fatPercentage }}%</v-subheader>
            </v-row>
            <v-row>
              <v-slider
                v-model="fatPercentage"
                @change="fatChanged"
                thumb-label
                step="1"
                min="0"
                max="100"
              ></v-slider>
              <v-text-field
                @input="fatChanged"
                type="number"
                v-model="fatPercentage"
                class="inputField flex-row-reverse mt-0 pt-0"
                outlined
                dense
              ></v-text-field>
            </v-row>
            <v-row>
              <v-subheader>Protein: {{ proteinGrams }}g</v-subheader>
              <v-subheader>Fat: {{ fatGrams }}g</v-subheader>
              <v-subheader>Carbs: {{ carbsGrams }}g</v-subheader>
              <v-subheader>Actual Calories: {{ actualCalories }}</v-subheader>
            </v-row>
          </v-col>
        </v-card>
      </v-container>
    </v-layout>
  </v-content>
</template>

<script>
export default {
  name: "MacroCalc",
  data: () => ({
    proteinPercentage: 20,
    carbPercentage: 60,
    fatPercentage: 20,
    calories: 2000,
    actualCalories: 1996,
    proteinGrams: 100,
    fatGrams: 44,
    carbsGrams: 300,
  }),
  methods: {
    calsChanges() {
      this.carbsVal();
      this.fatsVal();
      this.proteinVal();
      this.actualCaloriesVal();
    },
    totalCalc(whatChanged, val) {
      switch (whatChanged) {
        case "protein":
          this.proteinCalc(val);
          break;
        case "fat":
          this.fatCalc(val);
          break;
        case "carb":
          this.carbCalc(val);
          break;
      }
    },
    proteinChanged(val) {
      this.totalCalc("protein", val);
    },
    carbChanged(val) {
      this.totalCalc("carb", val);
    },
    fatChanged(val) {
      this.totalCalc("fat", val);
    },
    proteinCalc(val) {
      //protein is 4 cals per gram
      for (let i = 0; i < 4; i++) {
        this.fatPercentage = Math.floor(
          (this.fatPercentage / (this.fatPercentage + this.carbPercentage)) *
            (100 - val)
        );

        this.carbPercentage = Math.ceil(
          (this.carbPercentage / (this.carbPercentage + this.fatPercentage)) *
            (100 - val)
        );
      }
      this.carbsVal();
      this.fatsVal();
      this.proteinVal();
      this.actualCaloriesVal();
    },
    fatCalc(val) {
      //fat is 9 cals per gram
      for (let i = 0; i < 4; i++) {
        this.proteinPercentage = Math.floor(
          (this.proteinPercentage /
            (this.proteinPercentage + this.carbPercentage)) *
            (100 - val)
        );
        this.carbPercentage = Math.ceil(
          (this.carbPercentage /
            (this.carbPercentage + this.proteinPercentage)) *
            (100 - val)
        );
      }
      this.carbsVal();
      this.fatsVal();
      this.proteinVal();
      this.actualCaloriesVal();
    },
    carbCalc(val) {
      //carbs is 4 cals per gram
      for (let i = 0; i < 4; i++) {
        this.proteinPercentage = Math.floor(
          (this.proteinPercentage /
            (this.proteinPercentage + this.fatPercentage)) *
            (100 - val)
        );
        this.fatPercentage = Math.ceil(
          (this.fatPercentage / (this.fatPercentage + this.proteinPercentage)) *
            (100 - val)
        );
      }
      this.carbsVal();
      this.fatsVal();
      this.proteinVal();
      this.actualCaloriesVal();
    },
    proteinVal() {
      if (this.proteinPercentage > 0) {
        this.proteinGrams = Math.round(
          (parseInt(this.calories) * (this.proteinPercentage / 100)) / 4
        );
      } else {
        this.proteinGrams = 0;
      }
    },
    carbsVal() {
      if (this.carbPercentage > 0) {
        this.carbsGrams = Math.round(
          (parseInt(this.calories) * (this.carbPercentage / 100)) / 4
        );
      } else {
        this.carbsGrams = 0;
      }
    },
    fatsVal() {
      if (this.fatPercentage > 0) {
        this.fatGrams = Math.round(
          (parseInt(this.calories) * (this.fatPercentage / 100)) / 9
        );
      } else {
        this.fatGrams = 0;
      }
    },
    actualCaloriesVal() {
      this.actualCalories =
        this.fatGrams * 9 + this.proteinGrams * 4 + this.carbsGrams * 4;
    },
  },
  created() {},
  watch: {},
};
</script>

<style scoped>
.inputField {
  max-width: 80px !important;
}
</style>
